<template>
  <div class="chat-cta">
    <button
      class="text-us"
      :class="windowStateStore.textUsButtonVisible ? 'text-us--visible' : 'text-us--hidden'"
      type="button"
      aria-label="Text us"
      @click="textUsClicked"
    >
      <img class="text-us__img" :src="textUsImg" alt="" />
    </button>

    <button id="container" type="button" @click="chatNowClicked">
      <span class="label">Chat Now</span>
    </button>
  </div>
</template>
  
<script setup>
import textUsImg from "../assets/text_us.png";
import { useWindowStateStore } from "@/stores/useWindowStateStore";

const windowStateStore = useWindowStateStore();
const { toggleChatWindow } = windowStateStore;

function textUsClicked() {
  if (windowStateStore.chatWindowOpen) return;
  windowStateStore.showContactForm = true;
  toggleChatWindow();
}

function chatNowClicked() {
  toggleChatWindow();
}

</script>


<style scoped>
.chat-cta {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 50px;
}

#container {
  background-color: var(--primary-accent-base);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  overflow: visible;
  border: 0;
  box-shadow: 0 3px 20px 0 rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.16);
  height: 50px;
  width: 125px;
  cursor: pointer;
  padding: 0;
  position: relative;
  z-index: 2;
}

.text-us {
  width: 50px;
  height: 50px;
  border-radius: 999px;
  background: var(--primary-accent-base);
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-top: 3px;
  box-shadow: none;
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  transform: translateX(0);
  pointer-events: auto;
  animation-duration: 1000ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}

/* Hidden -> visible */
.text-us--visible {
  animation-name: sms-rollout;
}

/* Visible -> hidden */
.text-us--hidden {
  animation-name: sms-rollin;
}

@keyframes sms-rollout {
  0% {
    transform: translateX(0) rotate(0deg);
    box-shadow: none;
    opacity: 0;
  }
  100% {
    transform: translateX(-140px) rotate(-360deg);
    opacity: 1;
    box-shadow: 0 3px 20px 0 rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.16);
  }
}

@keyframes sms-rollin {
  0% {
    transform: translateX(-140px) rotate(0deg);
    opacity: 1;
    box-shadow: 0 3px 20px 0 rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.16);
  }
  100% {
    transform: translateX(0) rotate(360deg);
    box-shadow: none;
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .text-us {
    animation: none;
  }

  .text-us--visible {
    transform: translateX(-140px);
    opacity: 1;
    box-shadow: 0 3px 20px 0 rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.16);
  }

  .text-us--hidden {
    transform: translateX(0);
    opacity: 0;
    box-shadow: none;
  }
}

.text-us__img {
  height: 27px;
  object-fit: contain;
  display: block;
}

.label {
  font-size: 1.25rem;
  color: var(--white-dark);
  font-weight: 500;
}
</style>